import React, { memo } from 'react';

import SearchModule from 'Shared/components/SearchModule';
import { WpModal, WpModalHeader, WpModalBody } from 'Wpds/components/modal';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

import './index.scss';

type Props = {
  isOpen: boolean;
  onOpenToggle?: () => void;
};

function SearchModal({ isOpen, onOpenToggle }: Props) {
  const { tr } = useTranslation();

  return (
    <WpModal size="lg" isOpen={isOpen} onToggle={onOpenToggle} dismissOnBackdrop={false} zIndex={1064}>
      <WpModalHeader>{tr('perform.search.modal.title')}</WpModalHeader>
      <WpModalBody>
        <div className="SearchModal">
          <SearchModule onOpenToggle={onOpenToggle} />
        </div>
      </WpModalBody>
    </WpModal>
  );
}

export default memo(SearchModal);
